const Chat = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <g clip-path="url(#clip0_8326_2138)">
        <mask id="path-1-inside-1_8326_2138" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5856 20.5202C10.5856 20.5202 10.5857 20.5202 10.5857 20.5202C15.8434 20.5201 20.1056 16.2578 20.1056 11.0001C20.1056 5.74227 15.8433 1.47998 10.5855 1.47998C5.32772 1.47998 1.06543 5.74227 1.06543 11.0001C1.06543 13.2685 1.85881 15.3516 3.18323 16.9871C3.53175 17.4175 3.53646 18.0494 3.14487 18.441L2.77728 18.8085C2.1456 19.4402 2.59298 20.5203 3.48631 20.5203H10.5856C10.5856 20.5203 10.5856 20.5203 10.5856 20.5202Z"
          />
        </mask>
        <path
          d="M2.77728 18.8085L1.64283 17.6741L2.77728 18.8085ZM3.18323 16.9871L1.93642 17.9968L3.18323 16.9871ZM3.14487 18.441L2.01042 17.3065L3.14487 18.441ZM10.5857 20.5202L10.5857 22.1245L10.5857 20.5202ZM18.5013 11.0001C18.5013 15.3718 14.9573 18.9158 10.5857 18.9158L10.5857 22.1245C16.7295 22.1244 21.71 17.1439 21.71 11.0001H18.5013ZM10.5855 3.08433C14.9573 3.08433 18.5013 6.62833 18.5013 11.0001H21.71C21.71 4.85621 16.7294 -0.124374 10.5855 -0.124374V3.08433ZM2.66978 11.0001C2.66978 6.62833 6.21378 3.08433 10.5855 3.08433V-0.124374C4.44166 -0.124374 -0.538924 4.85621 -0.538924 11.0001H2.66978ZM4.43003 15.9774C3.32851 14.6172 2.66978 12.8877 2.66978 11.0001H-0.538924C-0.538924 13.6493 0.389117 16.0861 1.93642 17.9968L4.43003 15.9774ZM3.91173 19.943L4.27932 19.5754L2.01042 17.3065L1.64283 17.6741L3.91173 19.943ZM10.5856 18.9159H3.48631V22.1246H10.5856V18.9159ZM1.64283 17.6741C0.000470638 19.3165 1.16364 22.1246 3.48631 22.1246V18.9159C4.02232 18.9159 4.29073 19.564 3.91173 19.943L1.64283 17.6741ZM1.93642 17.9968C1.8727 17.9181 1.8356 17.8167 1.83744 17.7027C1.83939 17.5817 1.88795 17.429 2.01042 17.3065L4.27932 19.5754C5.32377 18.5309 5.2284 16.9633 4.43003 15.9774L1.93642 17.9968ZM10.5856 22.1246C11.4717 22.1246 12.19 21.4063 12.19 20.5202H8.98127C8.98127 19.6342 9.69954 18.9159 10.5856 18.9159V22.1246ZM10.5857 18.9158C9.70375 18.9158 8.98127 19.63 8.98127 20.5202H12.19C12.19 21.4104 11.4676 22.1245 10.5857 22.1245L10.5857 18.9158Z"
          fill="#1D1D1F"
          mask="url(#path-1-inside-1_8326_2138)"
        />
        <path
          d="M14.5655 10.6748C14.5655 12.8734 12.7831 14.6558 10.5845 14.6558C8.38587 14.6558 6.60352 12.8734 6.60352 10.6748"
          stroke="#1D1D1F"
          stroke-width="1.60435"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8326_2138">
          <rect
            width="20.0544"
            height="20.0544"
            fill="white"
            transform="translate(0.559082 0.972656)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Chat
